import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom';
import {constants} from "../config/constants";
import Cookies from "js-cookie";

export const CoachRoute = ({children}) => {
    const user = useSelector(state => state.auth);
    let access_token = Cookies.get(constants.zynity_api_access_token_cookie_name);
    if(access_token == undefined) {
        return <Navigate to="/site/login" replace />;
    }
    document.title = `Coach Dashboard | ${constants.website_title}`

    return user.is_coach === true
        ? children
        : <Navigate to="/" />
}
